import { createFileRoute } from '@tanstack/react-router'
import { CREATE_ACCESS } from '../../../app/access'
import { requireAccess } from '../../../app/guards'
import { NewRefundPage } from '../../../features/refunds/refund-pages'
import { newRefundSearchSchema } from '../../../features/refunds/search'
import { treasuryOptionsQueryOptions } from '../../../features/sales/queries'

export const Route = createFileRoute('/_app/refunds/new')({
  staticData: { crumb: 'refundNew' },
  validateSearch: newRefundSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, CREATE_ACCESS.refund),
  loader: ({ context }) => {
    // Warm the cash/bank picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(treasuryOptionsQueryOptions)
  },
  component: NewRefundPage,
})
